import React, { useState } from "react";
import "./Create_Account_step1.css";
import { Form } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import PhoneInput from "react-phone-input-2";
import "../../../common/common-css/CommonCss.css";
import Common_Btn from "../../../common/common-btn/Common_Btn";
import Form_Header from "../../../common/form-header/Form_Header";

const Create_Account_step1 = ({ step, totalSteps, setStep }) => {
  const progressWidth = (step / totalSteps) * 100;
  const [phone, setPhone] = useState("");
  const { control, handleSubmit } = useForm();
  return (
    <section id="user-register" className="step1_wrapper">
      <Form_Header step={1} totalSteps={6} />

      <div className="container">
        <Form className="auth_form">
          <div className="row">
            <div className="col-lg-6 mb-4">
              <Form.Group>
                <Form.Label>First Name</Form.Label>
                <Form.Control type="text" placeholder="Enter First Name" />
              </Form.Group>
            </div>

            <div className="col-lg-6 mb-4">
              <Form.Group>
                <Form.Label>Last Name</Form.Label>
                <Form.Control type="text" placeholder="Enter Last Name" />
              </Form.Group>
            </div>
            <div className="col-lg-6 mb-4">
              <Form.Group>
                <Form.Label>Date of Birth</Form.Label>
                <Form.Control type="date" />
              </Form.Group>
            </div>
            <div className="col-lg-6">
              <Form.Group className="mb-3">
                <Form.Label>Contact</Form.Label>
                <Controller
                  name=""
                  control={control}
                  defaultValue=""
                  rules={{ required: "Contact number is required" }}
                  render={({ field }) => (
                    <PhoneInput
                      country="in"
                      value={field.value}
                      onChange={(value) => field.onChange(value)}
                      enableSearch
                      inputClass="phone_input"
                      containerClass="phone_container"
                    />
                  )}
                />
              </Form.Group>
            </div>

            <Form.Group className="mb-4">
              <Form.Label>Enter Email Address</Form.Label>
              <Form.Control type="email" placeholder="Enter Email" />
            </Form.Group>

            <div className="col-lg-6 mb-4">
              <Form.Group>
                <Form.Label>Password</Form.Label>
                <Form.Control type="password" placeholder="Password" />
              </Form.Group>
            </div>

            <div className="col-lg-6 mb-5">
              <Form.Group>
                <Form.Label>Re-Enter Password</Form.Label>
                <Form.Control type="password" placeholder="Confirm Password" />
              </Form.Group>
            </div>

            <div className="form_btn_holder">
              <Common_Btn btnText={"Next"} onClick={() => setStep(2)} />
            </div>
          </div>
        </Form>
      </div>
    </section>
  );
};

export default Create_Account_step1;
